import { render, staticRenderFns } from "./sztd.vue?vue&type=template&id=cae07e5a&scoped=true"
import script from "./sztd.vue?vue&type=script&lang=js"
export * from "./sztd.vue?vue&type=script&lang=js"
import style0 from "./sztd.vue?vue&type=style&index=0&id=cae07e5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae07e5a",
  null
  
)

export default component.exports